/**
 * AppShell Layout Constants
 * Centralized dimensions for consistent layout across shell components
 */

// ===== TOPBAR DIMENSIONS =====

/** TopBar height in pixels */
export const TOPBAR_HEIGHT = 56;

// ===== NAVIGATION ITEM DIMENSIONS =====

/** NavItem icon size in pixels */
export const NAV_ITEM_ICON_SIZE = 20;

// ===== BADGE CONFIGURATION =====

/** Badge text max length before showing "99+" */
export const BADGE_MAX_VALUE = 99;
